import {
    HttpContextToken,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheService } from 'app/core/cache/cache.service';
import { Observable, of, tap } from 'rxjs';

/**
 * Cache Type
 *
 * @usageNotes
 * TRUE: response will be cached (cache will be cleared after 1 Hour),
 * FALSE: no cache,
 * Number: response will be cached for specified number of seconds
 */
export const CACHE: HttpContextToken<boolean | number> = new HttpContextToken(
    () => false
);

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    constructor(private _cache: CacheService) {}
    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Check cache enabled or not
        const cache = req.context.get(CACHE);

        // continue if not required
        if (!cache) {
            return next.handle(req);
        }

        const cachedResponse = this._cache.get(req);
        return cachedResponse
            ? of(cachedResponse)
            : this.sendRequest(req, next, this._cache);
    }

    /**
     * Get server response observable by sending request to `next()`.
     * Will add the response to the cache on the way out.
     */
    sendRequest(
        req: HttpRequest<any>,
        next: HttpHandler,
        cache: CacheService
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event) => {
                // There may be other events besides the response.
                if (event instanceof HttpResponse) {
                    cache.put(req, event); // Update the cache.
                }
            })
        );
    }
}
